export const MESSAGES_PAGE = 100;
export const MOOD_POLL_KEY = 'Mood Poll';
